<div #panel class="uk-position-relative comments-panel">

  <!-- top spacer to create scrollable negative area when needed -->
  <div class="top-spacer" [style.height.px]="topOffset"></div>

  @if (observablesReady) {
    @for (thread of sectionThreads; track thread.id) {
      <div class="thread-wrapper uk-position-absolute uk-width-expand"
        [class.thread--focused]="thread.id === focusedThreadId"
        [style.top.px]="layoutMap.get(thread.id)?.top ?? 0"
        [style.z-index]="showInputMap.get(thread.id) ? 100 : 0"
        (click)="onThreadClick(thread)">
        <div measureComment [threadId]="thread.id" (sizeChange)="onCommentSizeChange(thread.id, $event)"
             class="uk-card uk-card-default uk-card-small uk-animation-slide-top-medium comment-card film-card">
          <div class="uk-card-body">
<!--            <div class="comment-header">-->
<!--              <strong>{{ thread.fieldId }}</strong><br>-->
<!--              <strong>{{ thread.id }}</strong><br>-->
<!--              top - {{ layoutMap.get(thread.id)?.top}}-->
<!--            </div>-->
            <div class="comment-messages">
              @if (thread.id === 'tmpThreadId') {
                <div class="uk-width-expand">
                  <p class="uk-margin-small-top uk-margin-remove-bottom">{{ getDisplayName(userId) }}</p>
                </div>
                <div style="position: relative;">
                  <textarea id="thread-creation-text-area" class="uk-textarea"
                            placeholder="Comment or add others with @"
                            [value]="createThreadComment.body ?? ''"
                            (input)="onThreadCreationInputChange($any($event.target).value)">
                  </textarea>
                  @if (showMentionDropdown && activeThreadIdForMention === 'tmpThreadId') {
                    <div class="mention-dropdown uk-card uk-card-default uk-card-small">
                      @for (user of filteredUsers; track user.email) {
                        <div class="mention-option uk-padding-xsmall"
                             [attr.uk-tooltip]="user.email"
                             (click)="selectMentionForThread(user)">
                          {{ user.name ?? user.email }}
                        </div>
                      }
                    </div>
                  }
                </div>

              } @else {

                @for (comment of thread.messages; track comment.id) {
                  <div class="comment-wrapper">
                    <div class="uk-visible-toggle" tabindex="-1">

                      <div data-uk-grid>
                        <div class="uk-width-expand">
                          <p class="uk-margin-small-top uk-margin-remove-bottom">{{ getDisplayName(comment.authorId) }}</p>
                        </div>
                        @if (userId === comment.authorId) {
                          <div class="uk-width-auto">
                            <ul class="uk-hidden-hover uk-iconnav">
                              <li>
                                <div class="uk-inline">
                                  <a (click)="closeOverlay()">
                                    <span class="material-symbols-outlined uk-margin-small-top" style="font-size: 22px">more_vert</span>
                                  </a>
                                  <div id="kebab-menu-{{comment.id}}" class="comment-dropdown"
                                       uk-dropdown="mode: click; animation: reveal-top; animate-out: true; duration: 250">
                                    <ul class="uk-nav uk-dropdown-nav">
                                      <li><a (click)="copyComment(comment)">Edit</a></li>
                                      <li><a (click)="openOverlay(comment.id, thread)">Delete</a></li>
                                    </ul>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        }
                      </div>

                      @if (comment.id !== editingComment?.id) {
                        <p class="uk-margin-remove-top comment-body" [innerHTML]="comment.body | mentionHighlight"></p>
                      } @else {
                        <textarea id="text-area-{{comment.id}}" class="uk-textarea" [(ngModel)]="editingComment.body"
                                  [ngModelOptions]="{standalone: true}">
                        </textarea>
                      }
                    </div>

                    <!-- COMMENT OVERLAY -->
                    @if (overlayCommentId === comment.id) {
                      <div class="comment-overlay uk-animation-fade" >

                        <div class="uk-margin-xsmall" (click)="$event.stopPropagation()">
                          <p class="uk-light uk-margin-remove">Delete this comment?</p>

                          <button class="uk-button uk-button-small uk-button-danger uk-margin-small-right"
                                  (click)="deleteComment(thread.id, comment.id)">Ok
                          </button>

                          <button class="uk-button uk-button-default uk-button-small" (click)="closeOverlay()">
                            Cancel
                          </button>
                        </div>

                      </div>
                    }
                  </div>
                }

                @if (!showInputMap.get(thread.id)) {
                  <div class="uk-flex uk-flex-right">
                    <a class="material-symbols-outlined uk-text-decoration-none" style="font-size: 24px"
                       (click)="toggleInput(thread.id)">reply
                    </a>
                  </div>
                } @else {
                  <div class="uk-flex uk-flex-bottom">
                    <div class="uk-width-expand uk-margin-xsmall-right" style="position: relative;">
                      <textarea class="uk-textarea uk-padding-xsmall" rows="2" placeholder="Reply or @mention (Ctrl+Enter to send)"
                                [value]="inputMessage"
                                (input)="onInputChange($any($event.target).value, thread.id)"
                                (keydown.control.enter)="$event.preventDefault(); sendComment(thread.id)">
                      </textarea>
                      @if (showMentionDropdown && activeThreadIdForMention === thread.id) {
                        <div class="mention-dropdown uk-card uk-card-default uk-card-small">
                          @for (user of filteredUsers; track user.email) {
                            <div class="mention-option uk-padding-xsmall"
                                 (click)="selectMention(user, thread.id)">
                              {{ user.name ?? user.email }}
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <div class="uk-width-auto">
                      <a class="material-symbols-outlined uk-text-decoration-none" style="font-size: 24px"
                         (click)="sendComment(thread.id)">send
                      </a>
                    </div>
                  </div>
                }
              }
            </div>
          </div>

          @if (isEditingInThread(thread)) {
            <div class="uk-card-footer uk-flex uk-flex-between">
              <button class="uk-button uk-button-default uk-button-small"
                      (click)="editingComment = null">Cancel</button>
              <button class="uk-button uk-button-primary uk-button-small"
                      (click)="updateComment(thread.id, editingComment)"
                      [ngClass]="{'uk-disabled': editingComment.body.trim() === ''}">
                Save
              </button>
            </div>
          }

          @if (thread.id === 'tmpThreadId') {
            <div class="uk-card-footer uk-flex uk-flex-between">
              <button class="uk-button uk-button-default uk-button-small"
                      (click)="clearTemporaryThread()">Cancel</button>
              <button class="uk-button uk-button-primary uk-button-small"
                      (click)="createThread(thread.fieldId, createThreadComment.body)"
                      [ngClass]="{'uk-disabled': !createThreadComment?.body || createThreadComment?.body?.trim() === ''}">
                Comment
              </button>
            </div>
          }

          <!-- OVERLAY FOR DELETING ENTIRE THREAD -->
          @if (overlayThreadId === thread.id) {
            <div class="card-overlay uk-animation-fade" (click)="closeOverlay()">
              <div class="uk-margin-xsmall" (click)="$event.stopPropagation()">
                <p class="uk-light uk-margin-remove">Delete entire thread?</p>

                <div class="uk-margin-small-top">
                  <button class="uk-button uk-button-danger uk-button-small uk-margin-small-right"
                          (click)="deleteThread(thread.id)">Ok
                  </button>

                  <button class="uk-button uk-button-default uk-button-small" (click)="closeOverlay()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          }

        </div>
      </div>
    }
  } @else {
    <div class="uk-text-center">Loading...</div>
  }
</div>
